import { AppRoutes } from "@/infra/router";
import { Button, NotFoundPage as NotFoundPageShared } from "@akina/presentation";
import { Link } from "react-router-dom";

export function NotFoundPage() {
    return (
        <NotFoundPageShared
            button={
                <Link to={AppRoutes.DashboardToday}>
                    <Button>Go back to home</Button>
                </Link>
            }
        />
    );
}